import { Route, Switch } from "react-router-dom";

import InsightComponent from "../../components/page/insight/InsightComponent";

const InsightPage = () => {
  return (
    <Switch>
      <Route exact path="/insight" component={InsightComponent} />
    </Switch>
  );
};

export default InsightPage;
